/** inbound email webhook shapes (docs/53 §6.3). See ./index.ts for the verification rule and the VERIFY note. */
import { z } from 'zod';
import { Email } from '../common.ts';

/** What the Email Worker extracts before anything is stored (docs/53 §7.5). */
export const InboundEmailEnvelope = z.object({
  to: Email,
  from: Email,
  subject: z.string().max(998),
  spf: z.enum(['pass', 'fail', 'softfail', 'neutral', 'none', 'temperror', 'permerror']),
  dkim: z.enum(['pass', 'fail', 'none', 'temperror', 'permerror']),
  dmarc: z.enum(['pass', 'fail', 'none']).optional(),
  attachments: z.array(z.object({ filename: z.string().max(255), contentType: z.string().max(100), bytes: z.number().int().min(0) })).max(50),
});
